import { useTranslation } from 'react-i18next'

import { Select } from '@/components/v2/ui'
import { EID } from '@/lib/element-ids.registry'

interface RemakeVersion {
  id: string
  marketplace_code: string
  version_number: number
  status: string
}

interface RemakeVersionSelectProps {
  versions: RemakeVersion[]
  value: string | null
  onChange: (remakeId: string) => void
}

/** Dropdown to switch between remake versions, e.g. "amazon · v2 (completed)". */
export function RemakeVersionSelect({ versions, value, onChange }: RemakeVersionSelectProps) {
  const { t } = useTranslation()

  const options = versions.map((v) => ({
    value: v.id,
    label: `${v.marketplace_code} · v${v.version_number} (${v.status})`,
  }))

  return (
    <Select
      id={EID['listing-builder-remake-version-select']}
      label={t('listingBuilder.remake.versionLabel')}
      placeholder={t('listingBuilder.remake.versionPlaceholder')}
      options={options}
      value={value ?? undefined}
      onValueChange={onChange}
    />
  )
}
